import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { authenSelector, updateAuthen, useAuthStore } from 'modules/auth/core';
import { onLogout } from 'modules/layout/core/constrollers/master-layout';

import { apiCall } from 'hooks/service';

import { PATH } from 'constants/path';

import { API_URL } from '../constants/environment';

const getAccessToken: () => string = () => {
  /*TODO: Get user's access token from your current storage
    E.g: localStorage.getItem("access_token")
   */
  const auth = authenSelector(useAuthStore.getState());

  return auth?.token;
};

const createHeaderToken = () => {
  const tokenType = 'Bearer'; //Modify your logic to get more token types
  const accessToken = getAccessToken();

  return `${tokenType} ${accessToken}`;
};

const initAxiosInterceptor = () => {
  axios.interceptors.request.use((config) => {
    //Set timeout if server takes too long to response: config.timeout = DEFAULT_MAX_TIMEOUT;
    config.url = `${config.url?.indexOf('http') !== 0 ? API_URL : ''}${config.url}`;
    config.headers.Authorization = createHeaderToken();
    config.headers.Accept = 'application/json';
    config.headers['ngrok-skip-browser-warning'] = 'any value';

    //TODO: If you want loading effect when sending request, put your start loading function here
    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      //Put your close loading function here
      return response;
    },
    async (error: AxiosError) => {
      //Put your close loading function here
      const statusCode = error.response ? error.response.status : null;

      const originalRequest = error.config as InternalAxiosRequestConfig<any>;

      switch (statusCode) {
        case 401:
          //Implement your Unauthorized request handler here
          // eslint-disable-next-line
          const refreshToken = authenSelector(useAuthStore.getState())?.refreshToken;

          if (refreshToken) {
            const response: { token: string } = await apiCall({
              url: '/refresh',
              method: 'POST',
              data: {
                refreshToken,
              },
            });

            const newAccessToken = response.token;

            updateAuthen({
              token: newAccessToken,
            });

            // Update the original request with the new token
            originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;

            // Retry the original request
            return axios(originalRequest);
          }

          if (window.location.pathname !== PATH.LOGIN) {
            onLogout();
            window.location.href = PATH.LOGIN;
          }

          break;

        case 404:
          //Implement your Unauthorized request handler here
          break;

        //Add more handler here if needed
        default:
          break;
      }

      return Promise.reject(error);
    },
  );
};

const publicAxiosInstance = axios.create({
  baseURL: API_URL,
});

export { initAxiosInterceptor, publicAxiosInstance };

export const instanceExternalUrl = axios.create({
  baseURL: '',
});
